<template>
  <div>
    <div class="kc-crumbs">
      <router-link v-if="type == 'bookCourse'" :to="`/BookCourseDetail?id=${courseId}`">{{courseName}}</router-link>
      <router-link v-else :to="`/CourseDetail?id=${courseId}`">{{courseName}}</router-link>
      <img src="../../assets/img/icon-more.png">
      <a href="javascript:;" class="kc-crumbs-state">课程反馈</a>
    </div>
    <div class="feedback-container">
      <div class="feedback-table">
        <textarea v-model="feedback"  class="fill-texta" placeholder="请告诉我们你遇到的问题或想反馈的意见"></textarea>
        <div class="feedback-btn"><button @click="submitfeed">提交反馈</button></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ApiFeedback} from '../../net/course/index.js'
  export default{
    data:function(){
      return{
        feedback : '',
        courseId : null,
        courseName:'',
        type: ''
      }
    },
    methods: {
      submitfeed(){
        const param = {courseId : this.courseId ,content : this.feedback}
        if(this.feedback){
          ApiFeedback(param).then(res=>{
            this.$message({
                      message: '反馈成功',
                      type: 'success'
                    });
            this.$router.go(-1);
          }).catch(err=>{
            //this.$message.error(err);
            this.$router.go(-1);
          })
        }
      }
    },
    mounted() {

    },
    created() {
      this.courseId = this.$route.query.id;
      this.courseName = this.$route.query.courseName;
      this.type = this.$route.query.type;
    }
  }
</script>

<style scoped="scoped">
  .feedback-container{
  	width: 1140px;
  	margin: 0 auto;
  	margin-top: 20px;
  	margin-bottom: 20px;
  	background:#fff;
  	min-height: 500px;
  	border-radius: 6px;
  }
  .feedback-table{
  	width: 860px;
  	margin:0 auto;
  }
  .fill-texta{
  width: 838px;
  height: 200px;
  font-size: 16px;
  color: #191919;
  outline: none;
  resize: none;
  margin-bottom: 20px;
  margin-top: 100px;
  padding: 10px;
  border: 1px solid #999;
  border-radius: 2px;
  }
  .feedback-btn{
  	width: 100%;;
  	text-align: center;
  	margin: 0 auto;
  }
  .feedback-btn button{
  	width: 180px;
  	height: 48px;
  	background-color: #0AAC50;
  	border-radius: 6px;
  	color: #fff;
  	font-size: 16px;
  	border:none;
  	cursor:pointer;
  	}
  .feedback-btn button:hover{
  	background-color: #019B3C;
  	cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Feedback/Feedback.vue